import { FormGroup } from '@angular/forms';
import { CheckoutShipToFormConfig } from 'app/_components/checkout-ship-to/checkout-ship-to.service';
import { mapErrorKeysToMessages } from './map-error-messages';

export function shipToValidator(
  isCash: boolean,
  addressRequired: boolean,
  isCanadaUser: boolean,
  regexCanadaPostalPattern: RegExp,
  regexUSAPostalPattern: RegExp,
  regexPhonePattern: string
) {

  return (form: FormGroup) => {
    const customerName = form.get('customerName')?.value || "";
    const streetAddress = form.get('streetAddress')?.value || "";
    const postalCode = form.get('postalCode')?.value || "";
    const phoneNumber = form.get('phoneNumber')?.value || "";
    const city = form.get('city')?.value || "";
    const state = form.get('state')?.value || "";

    let errorsMap: any = {
      "customerName.maxlength": (customerName !== "" && customerName?.length > CheckoutShipToFormConfig.customerName.maxLength),
      "customerName.required": (isCash && customerName === "") || (streetAddress === "" && customerName === ""),
      "postalCode.required": postalCode === "",
      "postalCode.pattern": (postalCode !== "" && (isCanadaUser ? !regexCanadaPostalPattern.test(postalCode) : !regexUSAPostalPattern.test(postalCode))),
      "streetAddress.maxlength": streetAddress !== "" && streetAddress?.length > CheckoutShipToFormConfig.streetAddress.maxLength,
      "streetAddress.required": addressRequired && streetAddress === "",
      "phoneNumber.required": phoneNumber === "" && (streetAddress === "" || isCash),
      "phoneNumber.pattern": (phoneNumber !== "" && !new RegExp(regexPhonePattern).test(phoneNumber)),
      "state.required": addressRequired && state === "",
      "city.required": addressRequired && city === ""
    };

    return mapErrorKeysToMessages(errorsMap);
  }
}
